module.exports = __webpack_public_path__ + "static/img/fr_yyzz.cf3d06d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/fr_yyzz.jpg
// module id = /uZk
// module chunks = 1